// extracted by mini-css-extract-plugin
module.exports = {"links":"Login_links__1BSd0","boxWrapper":"Login_boxWrapper__107KQ"};